export const LeadOwnerDashboardPermissions = {
  LeadOwnerDashboard :
  {
      permissionsId:'6497c8dd-d2e5-43c4-7763-08db970bd196',
      permissionsName :'Lead Owner Dashboard',
      componentsId:null,
      components:null , 
    }
} ;
